import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router  } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

import { Ress } from './users.model';
import { MessageService } from './message.service';

import { NgbDateStruct, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MessageBoxComponent }    from '../c9902-messagebox/messagebox.component';
// import { UsersService } from './users.service';

declare var $;

@Injectable()
export class CommonService {

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private modalService: NgbModal,
    private router: Router,
    ) { }

  temp_modal_contents:any =[];
  httpOptions={ headers : new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    })
  };
  Options={ 
    headers : new HttpHeaders({'Content-Type': 'application/json'})
  };

  //Loading Start サービスがAPIをコールする前で呼ぶ
  loadingStart():void{
      var h = $(window).height(); //ブラウザウィンドウの高さを取得
      $('#loader-bg').height(h).css('display','block'); //ウィンドウの高さに合わせでローディング画面を表示
      var userAgent = window.navigator.userAgent.toLowerCase();// 使用しているブラウザの判定
      if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
        //
      } else {
        this.httpOptions={
          headers : new HttpHeaders({'Content-Type': 'application/json'})
        };
      }
  }
  //Loading End サービスがAPIリターンした時に呼ぶ
  loadingEnd():void{
    $('#loader-bg').delay(10).fadeOut(10);
  }

  modalOpens(msgid, callback: (modalresult: any) => void) {
    const modalRef = this.modalService.open(
        MessageBoxComponent,//対象のComponent
        { backdrop: 'static', keyboard: false }//オプション設定　Esc,背景クリックの時の処理…停止中
    );

    if (msgid == null){
      //auth::checkのエラー時
      modalRef.componentInstance.message_text = 'Please Sign in...';
      modalRef.componentInstance.message_mode = 3;
    }else if (this.messageService.getMessageDescription(msgid) == null){
      //auth::check以外のエラー時
      modalRef.componentInstance.message_text = msgid;
      modalRef.componentInstance.message_mode = 3;
    }else{
      //msgid指定時
      modalRef.componentInstance.message_text = this.messageService.getMessageDescription(msgid)[0].message;
      modalRef.componentInstance.message_mode = this.messageService.getMessageDescription(msgid)[0].mode; //ボタン
    }
    modalRef.result.then(
      result => {
        if (result.status=='Cancel'){
          //Cancel時の処理
          callback("Cancel")
        } else if(result.status=='OK'){
              //OK時の処理
            if(msgid == null){
//              this.usersService.clearUserInfo();
              this.router.navigate(["/signin"]);
            }else{
              this.temp_modal_contents =  result;
              callback("OK");
            }
        }else {
        }
      }, function () {
        // Esc,背景クリックの時の処理…オプション設定で停止中
        // console.log('dismissed');
        }
    );
  }
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  public handleError<T> (operation = 'operation', result?: T) {
    
    return (error: any): Observable<T> => {
      this.loadingEnd();
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  public exchange01toTF(checkFlg):boolean{
    if (checkFlg==0){
        return false;//0
    }else{
        return true;//1
    }
  }
  public exchangeTFto01(checkFlg):number{
    if (checkFlg){
        return 1;//true
    }else{
        return 0;//false
    }
  }
  public exchangeDateFormat1(dates:string):any{ 
    var result=dates.split('-');
    return {
      year: Number(result[0]),
      month: Number(result[1]),
      day: Number(result[2]),
    }
  }
  public exchangeDateFormat2(dates:any):Date{
    return new Date(dates.year, dates.month - 1, dates.day);
  }

  public typeEquals(type, obj) {
    var clas = Object.prototype.toString.call(obj).slice(8, -1);
    return clas === type;
  }
   
  formatYYYYMMDD(date: NgbDateStruct): string {
    if(this.typeEquals('Object', date)){
          return date.year +'/'+("0"+date.month).slice(-2)+'/'+("0"+date.day).slice(-2);
    }else{
        return null;
    }
  }
  formatYYYYMMDD2(date: NgbDateStruct): string {
    if(this.typeEquals('Object', date)){
          return date.year +'-'+("0"+date.month).slice(-2)+'-'+("0"+date.day).slice(-2);
    }else{
        return null;
    }
  }
  formatYYYYMM(date: NgbDateStruct): string {
    if(this.typeEquals('Object', date)){
          return date.year +'/'+("0"+date.month).slice(-2);
    }else{
        return null;
    }
  }
  formatYoyakudate(d, i) {
    //1月1日の場合は年/月/日
    //1日の場合は月/日
    //最初の行は月/日
    //それ以外は日
    let tmpdate = this.exchangeDateFormat1(d);      
    if ((tmpdate.month == 1) && ( tmpdate.day==1)) {
      return tmpdate.year +'/'+tmpdate.month+'/'+tmpdate.day;
    } 
    // else if ((i == 0) || ( tmpdate.day==1)) {
    //   return tmpdate.month+'/'+tmpdate.day;
    // } 
    else {
      return tmpdate.month+'/'+tmpdate.day;
    }
  }
  public checkDupRecords(datalist:any,key:string):boolean{
    if (datalist.length<=1){
      return false;
    }
    var row1 = datalist.filter(
      item => 
          item[key] != null 
    );  

    if (row1.length<=1){
      return false;
    }
    var row2 = row1.filter(
      (obj1, i, self) => (
        self.findIndex(obj2 => obj2[key] === obj1[key] || obj1[key] === null ) === i
      )
    );
    if ((row1.length) == (row2.length)){
      return false;
    }else{
      return true;
    }

  //   let data1 = JSON.parse(JSON.stringify(datalist));
  //   let data2 = JSON.parse(JSON.stringify(datalist));
  //     for (var i = 0; i < data1.length; i++) {
  //       if (data1[i][key] != null) {
  //         for (var j = 0; j < data2.length; j++) {
  //           if (data1[i][key] == data2[j][key] && data2[j][key] != null && i!=j ) {
  //             return true;
  //           }
  //       }
  //     }
  //     return false;
  // }
}

  public checkDuplicateRecords(datalist:any,key:string):any{
    return datalist.filter(
      (obj1, i, self) => (
        self.findIndex(obj2 => obj2[key] === obj1[key] || obj1[key] === null ) === i
      )
    );
  }

  /*
  datalist：確認したいデータリスト
  key1：重複を確認したいキー項目
  key2：確認したいリストから除外する対象となるキー項目
  myrecord：今現在のレコード
  */
  public checkDatalistRecords(datalist:any,key1:string,key2:string,myrecord:any):any{
    return datalist.filter((v) => v[key1].toUpperCase() === myrecord[key1].toUpperCase() && v[key2] !== myrecord[key2] );
  }
  public get_file(_uri, _params) {
    var request = '';   /*GETリクエスト*/
    for (var key in _params) {
        if (request === '') {
            request += '?';
        } else {
            request += '&';
        }
        request += key + '=' + _params[key];
    }
    request = _uri + request;

    window.location.href = request;
  }

  public get_file_Value(id){
    var value = $("#"+id).val();
    return value;
  }
  public clear_file_Value(id){
      $("#"+id).val("");
  }
  
  public checkSamePageUrl(a:string,b:string){
    //url は「/person/50」と入ってくる
    let a_ary=a.split('/');
    let b_ary=a.split('/');
    if (a_ary[1]==b_ary[1]){
      // if (a_ary[2]==b_ary[2]){
      //     return false;            
      //   }else{
          return true;
        // }
    }else{
        return false;            
    }
  }
  //使用ブラウザの判定
  public getUserAgent(){
    var userAgent = window.navigator.userAgent.toLowerCase();

    if(userAgent.indexOf('msie') != -1 ||
            userAgent.indexOf('trident') != -1) {
        return 'Internet Explorer';
    } else if(userAgent.indexOf('edge') != -1) {
        return 'Edge';
    } else if(userAgent.indexOf('chrome') != -1) {
        return 'Google Chrome';
    } else if(userAgent.indexOf('safari') != -1) {
        return 'Safari';
    } else if(userAgent.indexOf('firefox') != -1) {
        return 'FireFox';
    } else if(userAgent.indexOf('opera') != -1) {
        return 'Opera';
    } else {
        return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/service/common.service.ts